import React, { useEffect, useRef, useState } from 'react';
import style from "./style.module.css";
import Link from '../../Link';
import { getIcon } from '../../../helpers/icons';
import { verifyPostcode } from '../../../helpers/postcode';
import AsyncGet from '../../Materials/AsyncGet';
import Spinner from '../../Spinner';
import { get } from 'lodash';
import { showToast } from '../../../helpers/notify';
import FormGroup from '../FormGroup';
const AddressFinder = (props) => {
    const { placeholder = "Find address (enter postcode)", icon = "Search", onAddressSelected = () => { }, disabled = false, label = false, searchValue = "", searchTrigger } = props;
    const [load, setLoad] = useState(false);
    const [keyword, setKeyword] = useState("");
    const [showSuggs, setShowSuggs] = useState(false);
    const [selected, setSelected] = useState({});
    const [lastId, setLastId] = useState("");
    const divRef = useRef(null);

    const handleClickOutside = (event) => {
        if (divRef.current && !divRef.current.contains(event.target)) {
            closeSearch();
        }
    };

    const checkPostCode = (toast = false) => {
        const match = verifyPostcode(keyword);
        if (match) {
            setShowSuggs(true);
            setLoad(Date.now());
        } else {
            setShowSuggs(false);
            if (toast) {
                showToast("Invalid postcode");
            }
        }
    }

    const closeSearch = () => {
        setShowSuggs(false);
        setKeyword("");
    }

    useEffect(() => {
        checkPostCode();
    }, [keyword]);

    useEffect(() => {
        if (searchValue) {
            setKeyword(searchValue);
            setShowSuggs(true);
            setLoad(Date.now());
        }
    }, [searchValue, searchTrigger]);

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const formatAddress = (address) => {
        return {
            full_address: address,
            address_line_1: get(address, 'Line1', '') + (get(address, 'Line2', '') ? (", " + get(address, 'Line2', '')) : ''),
            address_line_2: get(address, 'Line3', ''),
            city: get(address, 'City', ''),
            postcode: get(address, 'PostalCode', ''),
        }
    }

    return (
        <div className={style.finder} ref={divRef}>
            <FormGroup
                label={label}
                disabled={disabled}
                value={placeholder}
            >
                <div className={style.wrap}>
                    <input
                        placeholder={placeholder}
                        onChange={(e) => {
                            setKeyword(e.target.value);
                        }}
                        value={keyword}
                    />
                    {icon && (
                        <Link className={style.findIcon} onClick={() => checkPostCode(true)}>
                            <i className={getIcon(icon)}></i>
                        </Link>
                    )}
                    <AsyncGet
                        url="/list/address-finder"
                        loadOnMount={load}
                        paramsData={{ keyword, last_id: lastId }}
                        permissionText={false}
                        render={({ fetching, loaded, data }) => {
                            return (
                                <>
                                    {showSuggs && <div className={style.dropdownOptions}>
                                        {fetching === true && loaded === false && <div className={`${style.item} ${style.loading}`}><Spinner /></div>}
                                        {fetching === false && loaded === true && <>
                                            {get(data, 'list') && get(data, 'list', []).length > 0 && get(data, 'list', []).map((item) => {
                                                return (
                                                    <Link className={style.item} key={get(item, 'Id')}
                                                        onClick={() => {
                                                            if (get(item, 'Next', '') === "Find") {
                                                                setLastId(get(item, 'Id', ''));
                                                                setLoad(Date.now());
                                                            } else {
                                                                setLastId('');
                                                                setSelected(item);
                                                                closeSearch();
                                                            }
                                                        }}
                                                    >
                                                        <span>{get(item, 'Text')}</span>
                                                    </Link>
                                                )
                                            })}
                                            {(!get(data, 'list') || get(data, 'list', []).length <= 0) &&
                                                <div className={style.item}>No addresses were found</div>
                                            }
                                        </>}
                                    </div>
                                    }
                                </>
                            )
                        }}
                    />
                </div>
                <AsyncGet
                    url="/list/address-fetch"
                    loadOnMount={get(selected, 'Id')}
                    paramsData={{ id: get(selected, 'Id') }}
                    permissionText={false}
                    onFetch={({ data }) => {
                        onAddressSelected(formatAddress(get(data, 'list.0', {})))
                    }}
                />
            </FormGroup>
        </div>
    )
}

export default AddressFinder;